import React, {Fragment} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import styled from "styled-components"

import {H2} from "@irati/ui/src/Headings"
import padding from "@irati/ui/src/global/padding"
import {connect} from "@irati/store"
import media from "@irati/ui/src/global/media"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import Link from "@irati/ui/src/Link"
import id from "@irati/utils/id"
import Flex from "@irati/ui/src/Flex"
import {walletTracking} from "@irati-tracking/wallet"
import Wallet from "../../images/wallet_badge.svg"
import {IntroText} from "../IntroText"
import Image from "../styled/Image"

const Container = styled.div`
  ${media.desktop`
    margin-bottom: ${padding.small};
  `}
`

const handleFaqsClick = () => {
  walletTracking.clickFaqs()
}

const Intro = (props) => {
  const {isPhone, formatMessage} = props

  const idNamespace = id("intro", props)

  return (
    <Container id={idNamespace}>
      <Flex id={id("header", idNamespace)} alignItems="center">
        <Image src={Wallet} alt="" />
        <H2>
          <FormattedMessage id="wallet.intro.header" />
        </H2>
      </Flex>
      {!isPhone && (
        <Fragment>
          <IntroText message="wallet.intro.description" />
          <Link
            onClick={handleFaqsClick}
            id={id("faq-link", idNamespace)}
            href={formatMessage({id: "wallet.intro.faq.link.href"})}
            target="_blank">
            <FormattedMessage id="wallet.intro.faq.link.text" />
          </Link>
        </Fragment>
      )}
    </Container>
  )
}

Intro.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  formatMessage: PropTypes.func.isRequired
}

const mapStateToProps = ({mq}) => ({
  isPhone: get(mq, "lessThan.medium", false)
})

export default injectIntl(connect(mapStateToProps)(Intro))
